import { createAsyncThunk } from '@reduxjs/toolkit';
import ErrorNotifier from 'app/scripts/services/error-notifier';
import { deleteLiveBlog } from '../../api';

interface Payload {
  eventId: string;
}

interface Returned {
  eventId: string;
}

export const deleteLiveBlogEvent = createAsyncThunk<Returned, Payload>(
  'LIVE_BLOG/DELETE_LIVE_BLOG_EVENT',
  ({ eventId }: Payload) => {
    deleteLiveBlog({ eventId }).catch(err => {
      console.error(err);
      ErrorNotifier.notifyError(`Failed to delete live blog`, { eventId });
      throw err;
    });

    return { eventId };
  }
);
